import React, { useEffect, useMemo } from 'react'
import Typography from '../Typography'
import masterCardImage from "../../../../assets/creditCard/mastercard.png"
import visaImage from "../../../../assets/creditCard/visa.png"
import theme from '../../../theme'
import WarningIcon from '@mui/icons-material/Warning';
import { CardType } from '../../../../types/stripe';
import { capitalizeFirstLetter } from '../../../../helpers/utils'

interface Props{
  style:React.CSSProperties
  cardType:CardType,
  lastFourNumbers:string,
  expirationYear:number,
  expirationMonth:number,

}

export default function CreditCard({style,cardType,lastFourNumbers,expirationYear,expirationMonth}:Props) {

  const selectedCardImage=useMemo(()=>{
    switch (cardType){
      case "visa":
      return visaImage
      case "mastercard":
      return masterCardImage
      default :
      return visaImage
    }
  },[cardType])
  const isExpired=useMemo(()=>{
    const now = new Date()
    const actualYear= now.getFullYear() 
    const actualMonth= now.getMonth()+1    
    if(expirationYear<actualYear)return true
    if(expirationYear>actualYear)return false
    if(expirationMonth<actualMonth) return true
  },[expirationMonth,expirationYear])



  return (
    <div style={{
      ...style,
        // boxShadow:"#cfcccc7d 0px 0px 9px 6px",
        border:"1px solid #cfcccc7d",
        padding:theme.sizing.x2,width:"320px",
        borderRadius:theme.sizing.x1
        }}
        >
      <div className='flex' style={{paddingTop:theme.sizing.x2,paddingBottom:theme.sizing.x2 }}>       
        <div>
          <div  style={{border: "1px solid lightGrey", padding:theme.sizing.x1}}>
            <img  style={{height:theme.sizing.x5}} width={theme.sizing.x8} src={selectedCardImage}/>
          </div>
        </div>
        <div className='ms-4'>
          <Typography style={{fontWeight:600}} variant="button">{capitalizeFirstLetter(cardType)} ****{lastFourNumbers}</Typography>
          <Typography className='my-2' colorVariant="textLabel" variant="label">Scadenza {String(expirationMonth)}/{String(expirationYear)}</Typography>
          {isExpired&&
            <div  className='flex gap-3 items-center'>
 
              <WarningIcon  style={{color:"red"}}/>
              <Typography style={{textAlign:"end"}} colorVariant="error" variant="button">Scaduta</Typography> 
            </div>
          }
        </div>
      </div>
    </div>
  )
}
